import {ChangeDetectionStrategy, Component, computed, Injectable, Signal} from "@angular/core";
import {toSignal} from "@angular/core/rxjs-interop";
import {TranslateModule} from "@ngx-translate/core";
import {Observable} from "rxjs";
import {GruppeDatatjeneste} from "felles-ng2/tjenester/datalager/GruppeDatatjeneste";
import {alleGrupperMedType} from "felles-ng2/modell/gruppeModellHjelpere";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {GruppeModell, Gruppetype} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {MatTableModule} from "@angular/material/table";
import {ReactiveFormsModule} from "@angular/forms";
import {MatSortModule} from "@angular/material/sort";
import {GrupperListOrdinaereKomponent} from "web-ng2/moduler/gruppe/komponenter/grupper-list-ordinaere/grupper-list-ordinaere";
import {GrupperListInvitasjonerKomponent} from "web-ng2/moduler/gruppe/komponenter/grupper-list-invitasjoner/grupper-list-invitasjoner";
import {GrupperListMalerKomponent} from "web-ng2/moduler/gruppe/komponenter/grupper-list-maler/grupper-list-maler";

const debug = initDebugger('GrupperListKomponent');

@Component({
    selector: 'grupper-list',
    templateUrl: 'grupper-list.html',
    styleUrl: 'grupper-list.scss',
    imports: [
        TranslateModule,
        ReactiveFormsModule,
        MatTableModule, MatSortModule, GrupperListOrdinaereKomponent, GrupperListInvitasjonerKomponent, GrupperListMalerKomponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GrupperListKomponent {
    static ajsSelector = 'grupperList';

    alleGrupper: Signal<GruppeModell[]>;
    maler: Signal<GruppeModell[]>;
    ordinaere: Signal<GruppeModell[]>;

    constructor(private avhengigheter: GrupperListKomponentAvhengigheter) {
        this.alleGrupper = toSignal(this.avhengigheter.grupper(), {initialValue: []})
        this.maler = computed(() => alleGrupperMedType(this.alleGrupper(), Gruppetype.mal));
        this.ordinaere = computed(() => alleGrupperMedType(this.alleGrupper(), Gruppetype.ordinær));
    }

}

@Injectable({providedIn: 'root'})
export class GrupperListKomponentAvhengigheter {

    constructor(private gruppeDatatjeneste: GruppeDatatjeneste) {
    }

    grupper(): Observable<GruppeModell[]> {
        return this.gruppeDatatjeneste.tilgjengeligeGrupper();
    }
}

